import React from 'react';
import { motion } from 'framer-motion';
export function Education() {
  return <section className="py-24 bg-background" data-id="element-23">
      <div className="max-w-[1100px] mx-auto px-6 md:px-12" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="grid grid-cols-1 md:grid-cols-12 gap-12" data-id="element-25">
          <div className="md:col-span-4" data-id="element-26">
            <h3 className="font-sans text-sm font-semibold tracking-[0.2em] text-accent uppercase flex items-center gap-4" data-id="element-27">
              Education
              <span className="h-[1px] flex-1 bg-accent/20" data-id="element-28"></span>
            </h3>
          </div>

          <div className="md:col-span-8 flex flex-col md:flex-row gap-12 md:gap-24" data-id="element-29">
            <div data-id="element-30">
              <h4 className="font-serif text-2xl font-bold text-primary mb-2" data-id="element-31">
                New York University
              </h4>
              <p className="font-sans text-lg text-charcoal font-medium" data-id="element-32">
                Finance
              </p>
            </div>

            <div data-id="element-33">
              <h4 className="font-sans text-sm font-semibold tracking-widest text-warm-gray uppercase mb-4" data-id="element-34">
                Credentials
              </h4>
              <ul className="space-y-3" data-id="element-35">
                <li className="flex items-center gap-3 text-primary font-sans text-sm font-medium" data-id="element-36">
                  <span className="w-1.5 h-1.5 bg-accent rounded-full" data-id="element-37"></span>
                  CFA Charterholder
                </li>
                <li className="flex items-center gap-3 text-primary font-sans text-sm font-medium" data-id="element-38">
                  <span className="w-1.5 h-1.5 bg-accent rounded-full" data-id="element-39"></span>
                  FRM Certified
                </li>
                <li className="flex items-center gap-3 text-primary font-sans text-sm font-medium" data-id="element-40">
                  <span className="w-1.5 h-1.5 bg-accent rounded-full" data-id="element-41"></span>
                  GARP Member
                </li>
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}